import React, { HTMLAttributes } from 'react'
import styled from 'styled-components'
import { STypographyDesc, STypographySmall } from '@components/Typography'

export interface IContact extends HTMLAttributes<HTMLAnchorElement> {
  href?: string
  desc?: string
}

/*const SLink = styled(STypographySmall)`
  text-decoration: none;
`*/

const Contact: React.FC<IContact> = ({ desc, children }) => {
  return (
    <div>
      {children}
      {desc && (
        <STypographyDesc color="gray" lineHeight="14px">
          {desc}
        </STypographyDesc>
      )}
    </div>
  )
}

export default Contact
